import { JSX, useEffect } from "react";
import { useAppSelector } from "../../app/hooks";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../common/enums/RouteEnum";
import { getImage } from "../../common/utils/getImage";
import { LeaveInformationContent } from "./components/LeaveInformationContent";
import { TimeoutModalContainer } from "./modals/TimeoutModalContainer";
import { useInactivityTimer } from "./hooks/useInactivityTimer";
import { ChevronLeft } from "../../common/svg/ChevronLeft";

export const LeaveInformationPageContainer = (): JSX.Element | null => {
    const navigate = useNavigate();
    const { personInfo } = useAppSelector((state) => state.root);
    const { isTimeoutModalOpen } = useAppSelector(
        (state) => state.leaveInformation,
    );

    useEffect(() => {
        if (!personInfo?.choice) {
            navigate(RouteEnum.CHOICE_SELECTION);
        }
    }, [personInfo?.choice, navigate]);

    useInactivityTimer({ isTimeoutModalOpen });

    const image = getImage(personInfo?.choice);

    if (!image) {
        return null;
    }

    return (
        <div className={"p-leave-information"}>
            <div className={"p-leave-information__image"}>
                <div
                    className={"p-leave-information__image__back"}
                    onClick={() => navigate(RouteEnum.CHOICE_SELECTION)}
                >
                    <ChevronLeft />
                    <p>Reset your vote</p>
                </div>
                <img src={image} alt={personInfo?.choice} />
            </div>
            <LeaveInformationContent />
            {isTimeoutModalOpen && <TimeoutModalContainer />}
        </div>
    );
};
